import React from "react";
import { Box } from "@mui/material";
import { useActionBarHeight } from "./useActionBarHeight";

export interface InlineActionBarProps {
  children: React.ReactNode;
  sx?: React.ComponentProps<typeof Box>["sx"];
}

/**
 * InlineActionBar - Compact horizontal action bar for inline usage
 * Used when actions need to be displayed in a single row without wrapping
 */
const InlineActionBar: React.FC<InlineActionBarProps> = ({ children, sx }) => {
  const minH = useActionBarHeight();

  return (
    <Box
      sx={{
        display: "inline-flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "center",
        gap: 0.5,
        "& > *": { minHeight: minH, minWidth: minH },
        ...sx
      }}
    >
      {children}
    </Box>
  );
};

export default InlineActionBar;
